/**
 * Las tareas vencidas que avisa la campana — `OD-0048-ENMIENDA-02` F-02.
 *
 * Vencida es lo mismo que en la pantalla de Tareas: con fecha, y la fecha antes
 * de HOY en el día del usuario (`hoy` = AAAA-MM-DD local). Sin fecha no vence.
 * Se cuenta al cargar el panel: sin correo, sin cron y sin push (`OD-0050` D-05).
 */
export function contarVencidas(lista: ReadonlyArray<{ readonly dueDate: string | null }>, hoy: string): number {
  return lista.filter((a) => a.dueDate !== null && a.dueDate < hoy).length;
}

/** `OD-0062` E-11: las de HOY, con la misma regla de día. Las vencidas no cuentan aquí. */
export function contarDeHoy(lista: ReadonlyArray<{ readonly dueDate: string | null }>, hoy: string): number {
  return lista.filter((a) => a.dueDate === hoy).length;
}
